import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ReloadService {
    private readonly storageKey = 'navigateAfterReload';

    setPath(path: string): void {
        localStorage.setItem(this.storageKey, path);
    }

    getPath(): string | null {
        return localStorage.getItem(this.storageKey);
    }

    clearPath(): void {
        localStorage.removeItem(this.storageKey);
    }
}

